import React from 'react';
import styled from 'styled-components';
import * as BuilderUI from '../../../../components/Builder/BuilderUI';
import BuilderExecutionDateRange from '../../../../components/Builder/BuilderExecutionDateRange';
import ThinDivider from '../../../../components/ThinDivider';
import BuilderInspectConfig from './BuilderInspectConfig';

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;

const CohortSamplingSettings = () => (
  <Container>
    <BuilderUI.BuilderFieldContainer>
      <BuilderUI.BuilderFieldLabel>
        Data Range for Sampling
      </BuilderUI.BuilderFieldLabel>
      <BuilderExecutionDateRange />
    </BuilderUI.BuilderFieldContainer>
    <ThinDivider layout="vertical" size="short" />
    <BuilderUI.BuilderFieldContainer>
      <BuilderUI.BuilderFieldLabel>Sampling Rate</BuilderUI.BuilderFieldLabel>
      <BuilderInspectConfig />
    </BuilderUI.BuilderFieldContainer>
  </Container>
);

export default CohortSamplingSettings;
